import { ENGATI_ICON_URL } from 'consts/consts';

export const launcherIcon = {
	url: ENGATI_ICON_URL,
	calloutMessage: '',
	showClosedCallout: false,
	showMinimizedPopup: false,
};
